// React things
import { useEffect, useState, useRef } from "react";

// Styles
import style from "./DialogMenu.module.css";

// Stores
import useApplicationSettings from "../../Store/ApplicationSettings.js";

// Downloads files
import icon_close from "/icon-close.png";

export default function DialogMenu(props) {
  const containerRef = useRef(null);

  const [hide, setHide] = useState(props.hide);

  useEffect(() => {
    setHide(props.hide);
  }, [props]);

  const popDialogMenuContent = useApplicationSettings(
    (state) => state.popDialogMenuContent
  );

  function close() {
    setHide(true);
    containerRef.current.addEventListener("transitionend", () => {
      popDialogMenuContent(props.name);
    });
  }

  return (
    <div
      ref={containerRef}
      className={`${style["container"]} ${hide && style["hide"]}`}
    >
      <div className={style["header"]}>
        <img
          onClick={close}
          src={icon_close}
          className={`${style["close"]} ${
            !props.needCloseButton && style["hideCloseButton"]
          }`}
        />
      </div>
      {typeof props?.page == "function" &&
        props?.page({ close: close, ...props.props })}
    </div>
  );
}
